import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { __rest } from "tslib";
import { convertHttpClient, createRequestPolicyFactoryPolicy } from "@azure/core-http-compat";
import { bearerTokenAuthenticationPolicy, decompressResponsePolicyName } from "@azure/core-rest-pipeline";
import { authorizeRequestOnTenantChallenge, createClientPipeline } from "@azure/core-client";
import { parseXML, stringifyXML } from "@azure/core-xml";
import { isTokenCredential } from "@azure/core-auth";
import { logger } from "./log";
import { StorageRetryPolicyFactory } from "./StorageRetryPolicyFactory";
import { StorageSharedKeyCredential } from "./credentials/StorageSharedKeyCredential";
import { AnonymousCredential } from "./credentials/AnonymousCredential";
import { StorageOAuthScopes, StorageBlobLoggingAllowedHeaderNames, StorageBlobLoggingAllowedQueryParameters, SDK_VERSION } from "./utils/constants";
import { getCachedDefaultHttpClient } from "./utils/cache";
import { storageBrowserPolicy } from "./policies/StorageBrowserPolicyV2";
import { storageRetryPolicy } from "./policies/StorageRetryPolicyV2";
import { storageSharedKeyCredentialPolicy } from "./policies/StorageSharedKeyCredentialPolicyV2";
import { StorageBrowserPolicyFactory } from "./StorageBrowserPolicyFactory";
import { storageCorrectContentLengthPolicy } from "./policies/StorageCorrectContentLengthPolicy"; // Export following interfaces and types for customers who want to implement their
// own RequestPolicy or HTTPClient

export { StorageOAuthScopes };
/**
 * A helper to decide if a given argument satisfies the Pipeline contract
 * @param pipeline - An argument that may be a Pipeline
 * @returns true when the argument satisfies the Pipeline contract
 */

export function isPipelineLike(pipeline) {
  if (!pipeline || typeof pipeline !== "object") {
    return false;
  }

  var castPipeline = pipeline;
  return Array.isArray(castPipeline.factories) && typeof castPipeline.options === "object" && typeof castPipeline.toServiceClientOptions === "function";
}
/**
 * A Pipeline class containing HTTP request policies.
 * You can create a default Pipeline by calling {@link newPipeline}.
 * Or you can create a Pipeline with your own policies by the constructor of Pipeline.
 *
 * Refer to {@link newPipeline} and provided policies before implementing your
 * customized Pipeline.
 */

export var Pipeline = /*#__PURE__*/function () {
  /**
   * Creates an instance of Pipeline. Customize HTTPClient by implementing IHttpClient interface.
   *
   * @param factories -
   * @param options -
   */
  function Pipeline(factories) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Pipeline);

    this.factories = factories;
    this.options = options;
  }
  /**
   * Transfer Pipeline object to ServiceClientOptions object which is required by
   * ServiceClient constructor.
   *
   * @returns The ServiceClientOptions object from this Pipeline.
   */


  _createClass(Pipeline, [{
    key: "toServiceClientOptions",
    value: function toServiceClientOptions() {
      return {
        httpClient: this.options.httpClient,
        requestPolicyFactories: this.factories
      };
    }
  }]);

  return Pipeline;
}();
/**
 * Creates a new Pipeline object with Credential provided.
 *
 * @param credential -  Such as AnonymousCredential, StorageSharedKeyCredential or any credential from the `@azure/identity` package to authenticate requests to the service. You can also provide an object that implements the TokenCredential interface. If not specified, AnonymousCredential is used.
 * @param pipelineOptions - Optional. Options.
 * @returns A new Pipeline object.
 */

export function newPipeline(credential) {
  var pipelineOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!credential) {
    credential = new AnonymousCredential();
  }

  var pipeline = new Pipeline([], pipelineOptions);
  pipeline._credential = credential;
  return pipeline;
}

function processDownlevelPipeline(pipeline) {
  var knownFactoryFunctions = [isAnonymousCredential, isStorageSharedKeyCredential, isCoreHttpBearerTokenFactory, isStorageBrowserPolicyFactory, isStorageRetryPolicyFactory, isStorageTelemetryPolicyFactory, isCoreHttpPolicyFactory];

  if (pipeline.factories.length) {
    var novelFactories = pipeline.factories.filter(function (factory) {
      return !knownFactoryFunctions.some(function (knownFactory) {
        return knownFactory(factory);
      });
    });

    if (novelFactories.length) {
      var hasInjector = novelFactories.some(function (factory) {
        return isInjectorPolicyFactory(factory);
      }); // if there are any left over, wrap in a requestPolicyFactoryPolicy

      return {
        wrappedPolicies: createRequestPolicyFactoryPolicy(novelFactories),
        afterRetry: hasInjector
      };
    }
  }

  return undefined;
}

export function getCoreClientOptions(pipeline) {
  var _a;

  var _b = pipeline.options,
      v1Client = _b.httpClient,
      restOptions = __rest(_b, ["httpClient"]);

  var httpClient = pipeline._coreHttpClient;

  if (!httpClient) {
    httpClient = v1Client ? convertHttpClient(v1Client) : getCachedDefaultHttpClient();
    pipeline._coreHttpClient = httpClient;
  }

  var corePipeline = pipeline._corePipeline;

  if (!corePipeline) {
    var packageDetails = "azsdk-js-azure-storage-blob/".concat(SDK_VERSION);
    var userAgentPrefix = restOptions.userAgentOptions && restOptions.userAgentOptions.userAgentPrefix ? "".concat(restOptions.userAgentOptions.userAgentPrefix, " ").concat(packageDetails) : "".concat(packageDetails);
    corePipeline = createClientPipeline(Object.assign(Object.assign({}, restOptions), {
      loggingOptions: {
        additionalAllowedHeaderNames: StorageBlobLoggingAllowedHeaderNames,
        additionalAllowedQueryParameters: StorageBlobLoggingAllowedQueryParameters,
        logger: logger.info
      },
      userAgentOptions: {
        userAgentPrefix: userAgentPrefix
      },
      serializationOptions: {
        stringifyXML: stringifyXML,
        serializerOptions: {
          xml: {
            // Use customized XML char key of "#" so we can deserialize metadata
            // with "_" key
            xmlCharKey: "#"
          }
        }
      },
      deserializationOptions: {
        parseXML: parseXML,
        serializerOptions: {
          xml: {
            // Use customized XML char key of "#" so we can deserialize metadata
            // with "_" key
            xmlCharKey: "#"
          }
        }
      }
    }));
    corePipeline.removePolicy({
      phase: "Retry"
    });
    corePipeline.removePolicy({
      name: decompressResponsePolicyName
    });
    corePipeline.addPolicy(storageCorrectContentLengthPolicy());
    corePipeline.addPolicy(storageRetryPolicy(restOptions.retryOptions), {
      phase: "Retry"
    });
    corePipeline.addPolicy(storageBrowserPolicy());
    var downlevelResults = processDownlevelPipeline(pipeline);

    if (downlevelResults) {
      corePipeline.addPolicy(downlevelResults.wrappedPolicies, downlevelResults.afterRetry ? {
        afterPhase: "Retry"
      } : undefined);
    }

    var credential = getCredentialFromPipeline(pipeline);

    if (isTokenCredential(credential)) {
      corePipeline.addPolicy(bearerTokenAuthenticationPolicy({
        credential: credential,
        scopes: (_a = restOptions.audience) !== null && _a !== void 0 ? _a : StorageOAuthScopes,
        challengeCallbacks: {
          authorizeRequestOnChallenge: authorizeRequestOnTenantChallenge
        }
      }), {
        phase: "Sign"
      });
    } else if (credential instanceof StorageSharedKeyCredential) {
      corePipeline.addPolicy(storageSharedKeyCredentialPolicy({
        accountName: credential.accountName,
        accountKey: credential.accountKey
      }), {
        phase: "Sign"
      });
    }

    pipeline._corePipeline = corePipeline;
  }

  return Object.assign(Object.assign({}, restOptions), {
    allowInsecureConnection: true,
    httpClient: httpClient,
    pipeline: corePipeline
  });
}
export function getCredentialFromPipeline(pipeline) {
  // see if we squirreled one away on the type itself
  if (pipeline._credential) {
    return pipeline._credential;
  } // if it came from another package, loop over the factories and look for one like before


  var credential = new AnonymousCredential();

  var _iterator = _createForOfIteratorHelper(pipeline.factories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var factory = _step.value;

      if (isTokenCredential(factory.credential)) {
        // Only works if the factory has been attached a "credential" property.
        // We do that in newPipeline() when using TokenCredential.
        credential = factory.credential;
      } else if (isStorageSharedKeyCredential(factory)) {
        return factory;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return credential;
}

function isStorageSharedKeyCredential(factory) {
  if (factory instanceof StorageSharedKeyCredential) {
    return true;
  }

  return factory.constructor.name === "StorageSharedKeyCredential";
}

function isAnonymousCredential(factory) {
  if (factory instanceof AnonymousCredential) {
    return true;
  }

  return factory.constructor.name === "AnonymousCredential";
}

function isCoreHttpBearerTokenFactory(factory) {
  return isTokenCredential(factory.credential);
}

function isStorageBrowserPolicyFactory(factory) {
  if (factory instanceof StorageBrowserPolicyFactory) {
    return true;
  }

  return factory.constructor.name === "StorageBrowserPolicyFactory";
}

function isStorageRetryPolicyFactory(factory) {
  if (factory instanceof StorageRetryPolicyFactory) {
    return true;
  }

  return factory.constructor.name === "StorageRetryPolicyFactory";
}

function isStorageTelemetryPolicyFactory(factory) {
  return factory.constructor.name === "TelemetryPolicyFactory";
}

function isInjectorPolicyFactory(factory) {
  return factory.constructor.name === "InjectorPolicyFactory";
}

function isCoreHttpPolicyFactory(factory) {
  var knownPolicies = ["GenerateClientRequestIdPolicy", "TracingPolicy", "LogPolicy", "ProxyPolicy", "DisableResponseDecompressionPolicy", "KeepAlivePolicy", "DeserializationPolicy"];
  var mockHttpClient = {
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  request: request,
                  headers: request.headers.clone(),
                  status: 500
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
  var mockRequestPolicyOptions = {
    log: function log(_logLevel, _message) {
      /* do nothing */
    },
    shouldLog: function shouldLog(_logLevel) {
      return false;
    }
  };
  var policyInstance = factory.create(mockHttpClient, mockRequestPolicyOptions);
  var policyName = policyInstance.constructor.name; // bundlers sometimes add a custom suffix to the class name to make it unique

  return knownPolicies.some(function (knownPolicyName) {
    return policyName.startsWith(knownPolicyName);
  });
}